import React from "react";
import sadImage from "../../assets/images/sad.gif";
import "./style.css";
export const PageNotFound = () => {
  return (
    <div class="page-not-found flex ai-c">
      <h1>Hello</h1>
    </div>
  );
};
